/* eslint-disable import/no-anonymous-default-export */
export default {
	// 正式环境地址
	BASE_URL: 'https://xiaoaishop.com/prod-api/',
	SOCKET_URL: 'ws://150.158.157.212:8080/webSocket/',
	SOCKETIO_URL: 'https://xiaoaishop.com'
}
